<app-list-table-filters-wrapper
  [title]="'Fields' | translate"
  [parentRoute]="'/electronic-field-map'"
  [subtitle]="('Total' | translate) + ': ' + totalRecords()"
  [columns]="tableColumns()"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [(filterModel)]="filterModel"
  [filtersForms]="filtersForms"
  (applyFilters)="applyFilters()"
  (clearFilters)="clearFilters()"
  [isLoading]="loading"
  [storageKey]="null"
  [defaultParams]="defaultParams"
  [toggleFilter]="toggleFilter"
  [filtersParams]="filtersParams"
  (onRowClick)="openEditModal($event)"
  (onFilterSaved)="initStartAndEndDate()">

  <ng-container controller>
    <button
      pButton
      type="button"
      [label]="('Add' | translate) + ' ' + ('Field' | translate)"
      icon="pi pi-plus"
      class="p-button-primary mr-2"
      (click)="openAddModal()">
    </button>
    <button
      pButton
      type="button"
      [label]="'Export' | translate"
      icon="pi pi-download"
      class="p-button"
      (click)="menu.toggle($event)"
      [disabled]="isExporting">
      <ng-container *ngIf="isExporting">
        <i class="pi pi-spin pi-spinner" style="margin-left: 8px;"></i>
      </ng-container>
    </button>
    <p-menu
      #menu
      [model]="exportMenuItems()"
      [popup]="true"
      appendTo="body">
    </p-menu>
  </ng-container>

  <ng-template #regionTemplate let-row>
    <app-region-display [regionId]="row.region?.id ?? row.regionId"></app-region-display>
  </ng-template>

  <ng-template #nameTemplate let-row>
    {{ row?.field?.name }}
  </ng-template>

  <ng-template #areaTemplate let-row>
    <div class="flex flex-row-reverse w-full">
      <div class="flex-row-reverse">
        {{ (row?.field?.fieldArea | msfNumber) || '-' }}
      </div>
    </div>
  </ng-template>

  <ng-template #actionsTemplate let-row>
    <button
      pButton
      class="p-button-text p-button-sm p-button-rounded edit-button"
      (click)="openEditModal(row)"
      [pTooltip]="'Редактировать' | translate">
      <img
        src="../../../../../../assets/icons/main/light/edit-2-fill.svg"
        alt="Edit"
        class="edit-icon">
    </button>
  </ng-template>

  <ng-template #fieldSeasonsShortTemplate let-row>
    @if (row.seasons?.length) {
      <table class="season-mini-table">
        <thead>
          <tr class="season-header">
            <th></th>
            <th>{{ 'Crop' | translate }}</th>
            <th>{{ 'Planting date' | translate }}</th>
            <th>{{ 'Harvesting date' | translate }}</th>
            <th>{{ 'Area' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (season of (row.seasons | fieldListSeasonRows:translate.currentLang); track season.id) {
            <tr class="season-row">
              <td class="season-type">
                <app-status-tag
                  class="compact"
                  [label]="season.labelKey | translate"
                  [color]="season.tagColor">
                </app-status-tag>
              </td>
              <td class="season-crop">
                @if (season.cropColorHex; as color) {
                  <span class="crop-color-box" [style.background-color]="color"></span>
                }
                {{ season.cropName }}
              </td>
              <td class="season-dates">
                @if (season.isPlanned) {
                  {{ season.plantingDatePlan !== null ? (season.plantingDatePlan | dateFormatLang:translate.currentLang) : ' - ' }}
                } @else {
                  {{ season.plantingDate !== null ? (season.plantingDate | dateFormatLang:translate.currentLang) : ' - ' }}
                }
              </td>
              <td class="season-dates">
                @if (season.isPlanned) {
                  {{ season.harvestingDatePlan !== null ? (season.harvestingDatePlan | dateFormatLang:translate.currentLang) : ' - ' }}
                } @else {
                  {{ season.harvestingDate !== null ? (season.harvestingDate | dateFormatLang:translate.currentLang) : ' - ' }}
                }
              </td>
              <td class="season-area">
                {{ season.fieldArea !== null ? (season.fieldArea | msfNumber) : ' - ' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <span> - </span>
    }
  </ng-template>
</app-list-table-filters-wrapper>
